import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import FilesHelpers from '../../helpers/FileHelpers';
import TooltipOnHover from '../../components/TooltipOnHover';
import Timeago from '../../components/Timeago';
import { DeleteIcon, DlIcon } from '../../components/Icons';
import { KEYFileIcon, PDFFileIcon, DOCFileIcon, XLSIcon, PPTFileIcon, ZIPIcon, DefaultFileIcon } from '../../components/FileIcons';
import download from '../utils/download';

var getFileIcon = function getFileIcon(extension) {
  switch (extension) {
    case 'key':
      return KEYFileIcon;

    case 'pdf':
      return PDFFileIcon;

    case 'doc':
    case 'docx':
    case 'docm':
      return DOCFileIcon;

    case 'xlsx':
    case 'xlsm':
    case 'xls':
      return XLSIcon;

    case 'pptx':
    case 'pptm':
    case 'ppt':
      return PPTFileIcon;

    case 'zip':
      return ZIPIcon;

    default:
      return DefaultFileIcon;
  }
};

var FileBlock =
/*#__PURE__*/
function (_Component) {
  _inherits(FileBlock, _Component);

  function FileBlock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FileBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FileBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onDownload", function (event) {
      event.preventDefault();
      event.stopPropagation();
      download(_this.props.node.data.get('url'));
      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onDelete", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.editor.removeNodeByKey(_this.props.node.key);
    });

    return _this;
  }

  _createClass(FileBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          readOnly = _this$props.readOnly,
          getUser = _this$props.getUser,
          attributes = _this$props.attributes,
          node = _this$props.node,
          isFocused = _this$props.isFocused,
          isSelected = _this$props.isSelected;
      var url = node.data.get('url');
      var createdAt = node.data.get('createdAt');
      var name = node.data.get('name');

      var _node$data$getIn = node.data.getIn(['meta']),
          size = _node$data$getIn.size;

      var createdBy = node.data.get('createdBy');
      var FileIcon = getFileIcon(FilesHelpers.getExtensionFromURL(url));
      var user = getUser ? getUser(createdBy) : undefined;
      return React.createElement("a", Object.assign({
        href: url,
        onClick: this.onDownload,
        spellCheck: false,
        className: classNames('pointer flexbox width-full line-height-normal padding-right-medium border-small', 'background-white transition', 'shadow-medium-on-hover radius-large overflow-hidden no-selection margin-top-small', {
          'border-primary': isFocused || isSelected,
          'border-shade-40 border-shade-30-on-hover': !(isFocused || isSelected)
        })
      }, attributes), React.createElement("div", {
        className: "padding-medium flexbox flexbox-grow min-width-zero"
      }, React.createElement("div", {
        className: "flexbox flexbox-centered pointer shade-30 padding-right-normal"
      }, React.createElement(FileIcon, {
        size: 24
      })), React.createElement("div", {
        className: "flexbox-grow flexbox-column min-width-zero"
      }, React.createElement("div", {
        className: "black bold padding-bottom-small ellipsis",
        title: name
      }, name), React.createElement("div", {
        className: "shade-20"
      }, size && React.createElement(Fragment, null, React.createElement("span", {
        className: "bold"
      }, FilesHelpers.bytesToSize(size)), ', '), user ? React.createElement("span", null, "Uploaded by", ' ', React.createElement("span", {
        className: "bold padding-horizontal-smaller entity-highlight"
      }, "@", user ? user.username : 'someone')) : React.createElement("span", null, "Uploaded"), ' ', React.createElement(Timeago, {
        date: createdAt
      })))), React.createElement("div", {
        className: "padding-vertical-medium flexbox"
      }, !readOnly && React.createElement(TooltipOnHover, {
        id: "file-delete",
        placement: "top",
        tooltipContent: "Delete"
      }, React.createElement("div", {
        className: "margin-left-normal padding-normal pointer radius-normal red-on-hover shade-30 shadow-small-on-hover transition",
        onClick: this.onDelete
      }, React.createElement(DeleteIcon, {
        size: 16
      }))), React.createElement(TooltipOnHover, {
        id: "file-download",
        placement: "top",
        tooltipContent: "Download"
      }, React.createElement("div", {
        onClick: this.onDownload,
        className: "margin-left-normal padding-normal pointer radius-normal shade-10-on-hover shade-30 shadow-small-on-hover transition"
      }, React.createElement(DlIcon, {
        size: 16
      })))));
    }
  }]);

  return FileBlock;
}(Component);

export default FileBlock;